// extracted by mini-css-extract-plugin
module.exports = {"Label":"Label_Label__BHjqQ","white":"Label_white__2Rchh","red":"Label_red__3pzzD","required":"Label_required__1I66l"};